module.exports = __webpack_public_path__ + "537bbfa9146e601fe4dccf154eca16c4.svg";